import { AnnotationComponent } from '../../ui'

class EmphasisComponent extends AnnotationComponent {
  getTagName() {
    return 'em'
  }
}

export default EmphasisComponent
